export function createBuffer(gl: WebGL2RenderingContext): WebGLBuffer {
  const b = gl.createBuffer();
  if (b == null) {
    throw Error("failed to create buffer");
  }
  return b;
}
